<template>
  <component :is="currentForm" @toStep2="toStep2" @toStep3="toStep3" />
</template>

<script setup lang="ts">
import { computed, h, ref } from 'vue';
import Step1 from '~/pages/forgot-password/_components/Step1.vue';
import Step2 from '~/pages/forgot-password/_components/Step2.vue';
import Step3 from '~/pages/forgot-password/_components/Step3.vue';

const Step = {
  Step1: 1,
  Step2: 2,
  Step3: 3,
};

const step = ref(Step.Step1);
const nextStep = () => step.value++;
const prevStep = () => step.value--;

const currentForm = computed(() => {
  switch (step.value) {
    case Step.Step1:
      return Step1;
    case Step.Step2:
      return () => h(Step2, { email: form.value.email });
    case Step.Step3:
      return () => h(Step3, { email: form.value.email, code: form.value.code });
  }
});

const form = ref({
  email: '',
  code: '',
  password: '',
  confirmPassword: '',
});

const toStep2 = (email: string) => {
  step.value = Step.Step2;
  form.value.email = email;
};

const toStep3 = (code: string) => {
  step.value = Step.Step3;
  form.value.code = code;
};
</script>